import React, { useState } from 'react';
import './App.css';
import ThumbnailPreview from './components/ThumbnailPreview';
import BulkGenerator from './components/BulkGenerator';

export default function App() {
  const [tab, setTab] = useState('preview');

  return (
    <div className="app">
      <header className="app-header">
        <h1>YT <span>Thumbnail</span> Generator</h1>
        <div className="tab-bar">
          <button className={`tab-btn ${tab === 'preview' ? 'active' : ''}`}
            onClick={() => setTab('preview')}>Preview</button>
          <button className={`tab-btn ${tab === 'bulk' ? 'active' : ''}`}
            onClick={() => setTab('bulk')}>Bulk Generate</button>
        </div>
      </header>

      {tab === 'preview' ? <ThumbnailPreview /> : <BulkGenerator />}
    </div>
  );
}
